import { render } from "./TestResultDetailView.vue?vue&type=template&id=67313c02&scoped=true"
import script from "./TestResultDetailView.vue?vue&type=script&lang=js"
export * from "./TestResultDetailView.vue?vue&type=script&lang=js"

import "./TestResultDetailView.vue?vue&type=style&index=0&id=67313c02&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67313c02"]])

export default __exports__